// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607271205/js/" + chunkId + "." + {"44":"30a18180","225":"b0200ce9","481":"dce1f584","486":"acafd69e","770":"7a15bae8"}[chunkId] + ".0.04606113219398067.chunk.js";
};